import * as React from 'react';
import {Link} from "react-router-dom";
import {logOut} from "../../utilities/Utilities";

interface Props {
    active: number
}

export const Menu = (props: Props) => {
    const pozycja = (nr: number, to: string, tekst: string) =>
        <li>
            <Link to={to} className={props.active === nr ? 'active' : ''}
                  aria-current={props.active === nr ? 'page' : undefined}>{tekst}</Link>
        </li>;

    return <nav id={'menu'} aria-label={'Menu konta'}>
        <h2 className={'h3'}>Menu</h2>
        <hr/>
        <ul>
            {pozycja(1, '/konto', 'Moje konto')}
            {pozycja(2, '/karta', 'Karta')}
            {pozycja(5, '/twojsklep', 'Twój sklep stacjonarny')}
            <li>
                <button type={'button'} className={'link-button'} onClick={() => logOut()}>Wyloguj</button>
            </li>
        </ul>
    </nav>
}

Menu.defaultProps = {}
